export enum ChecklistAnswerType {
  Boolean = 0,
  Text = 1,
  Radio = 2,
}

export interface ChecklistItem {
  id?: number
  label: string
  answerType: ChecklistAnswerType
  options?: string[] | null
  order: number
}

export interface Checklist {
  id: number
  customerId: number
  name: string
  description?: string
  items: ChecklistItem[]
  createdAt: string
}

export interface CreateChecklistItemDto {
  label: string
  answerType: ChecklistAnswerType
  options?: string[] | null
  order: number
}

export interface CreateChecklistDto {
  name: string
  description?: string
  items: CreateChecklistItemDto[]
}

export interface UpdateChecklistDto {
  name: string
  description?: string
  items: CreateChecklistItemDto[]
}